import { mockComponent } from 'bloko/common/setupMockComponents';

import IconDynamic from 'bloko/blocks/icon/IconDynamic';
import IconLink from 'bloko/blocks/icon/IconLink';
import IconVerticalAlignment from 'bloko/blocks/icon/IconVerticalAlignment';
import IconColor from 'bloko/blocks/icon/colors.d';

const handler = {
    get: (target, prop) => {
        if (prop === '__esModule') {
            return true;
        }
        switch (prop) {
            case 'IconDynamic':
                return IconDynamic;
            case 'IconLink':
                return IconLink;
            case 'IconVerticalAlignment':
                return IconVerticalAlignment;
            case 'IconColor':
                return IconColor;
        }
        return mockComponent(prop);
    },
};

// eslint-disable-next-line no-restricted-syntax
const proxy = new Proxy({}, handler);

module.exports = proxy;
